// extracted by mini-css-extract-plugin
module.exports = {"display-text":"mandatory-inspector_display-text__3u_h9","manage-inspector-container":"mandatory-inspector_manage-inspector-container__2EcQP"};